import { Route } from '@angular/router';

export const withdrawRoutes: Route[] = [
  {
    path: 'withdraw/reason',
    loadComponent: () => import('../pages/withdraw/reason/reason.page'),
  },
  {
    path: 'withdraw/verify',
    loadComponent: () => import('../pages/withdraw/verify/verify.page'),
  },
  {
    path: 'withdraw/confirm',
    loadComponent: () => import('../pages/withdraw/confirm/confirm.page'),
  },
];
